import { Component } from '@angular/core';
import { ToolBarComponent } from "../../components/tool-bar/tool-bar.component";
import { SharedModule } from 'src/app/private/shared/shared.module';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import { ClientService } from 'src/app/private/services/client.service';
import { ChipModule } from 'primeng/chip';
import { AddClientComponent } from "../../components/clients/add-client/add-client.component";
import { Router } from '@angular/router';
import { DeleteClientComponent } from "../../components/clients/delete-client/delete-client.component";

@Component({
  selector: 'app-clients',
  imports: [ToolBarComponent, SharedModule, ChipModule, AddClientComponent, DeleteClientComponent],
  templateUrl: './clients.component.html',
  styleUrl: './clients.component.scss'
})
export class ClientsComponent {

  selectedProducts: any[] = [];

  totalRecords: number = 0;
  rows: number = 50; // Default page size
  pageSizeOptions = [10, 20, 50]; // Page size options for dropdown
  loading: boolean = false;
  clientsData: any[] = [];

  showEditClient: boolean = false;
  showDeleteClient: boolean = false;
  clientDataToEdit: any = null;

  displayAddModal: boolean = false;

  constructor(
    private localStorage: LocalStorageService,
    private api: ClientService,
    private router: Router
  ) { }


  clientActionItems: any[] = [
    {
      label: 'Options',
      items: [
        {
          label: 'Edit Client',
          icon: 'pi pi-fw pi-pencil',
          command: () => {
            // navigate to edit client page
            this.router.navigate(['/main/clients', this.clientDataToEdit.client_id]);
          }
        },
        {
          label: 'Delete Client',
          icon: 'pi pi-fw pi-trash',
          styleClass: 'delete-menu-item',
          command: () => {
            this.showDeleteClient = true;
          }
        }
      ]
    }
  ]






  loadClients(event: any) {
    this.loading = true;

    const page = event.first / event.rows;
    const size = event.rows;

    const body = {
      "page": page,
      "limit": size,
      "where": {

      },
      "order": {
        "col": "\"client\".\"updatedAt\"",
        "dir": "DESC"
      }
    }


    this.api.getAllClients(body).subscribe({
      next: (data) => {
        this.clientsData = data?.rows || [];
        this.totalRecords = data?.count || 0;
        this.loading = false;
      },
      error: () => {
        this.loading = false;
      },
    });
  }


  reloadClients() {
    this.loadClients({
      first: 0,
      rows: this.rows
    });
  }

  setClientData(client: any) {
    this.clientDataToEdit = client;
  }


}
